export enum BudgetTypes {
  Economy = "Economy",
  MidRange = "Mid-range",
  Luxury = "Luxury",
}

export enum SORTBY {
  ASC = "ASC",
  DESC = "DESC",
}

export enum ButtonVariants {
  Text = "text",
  Contained = "contained",
  Outlined = "outlined",
}

export enum ButtonSizes {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum ChipVariants {
  Deletable = "Deletable",
  Clickable = "Clickable",
}

export enum EnvType {
  DEV = "dev",
  STAGING = "staging",
  PRODUCTION = "production",
}

export enum ScreenTypes {
  History = "history",
  ForYou = "forYou",
  SingleItinerary = "singleItinerary",
  Reorder = "reorder",
  ItineraryInfo = "itineraryInfo",
  Adjust = "adjust",
  Edit = "edit",
  Preference = "preference",
  EmptyPage = "emptyPage",
  SavedItinerary = "savedItinerary",
  Booking = "booking",
  HotelDetails = "hotelDetails",
  TripDetails = "tropDetails",
  SaveTripsList = "saveTripsList",
  CurrentTrip = "currentTrip",
  MyTrips = "myTrips",
  SavedTrip = "savedTrip",
  Preferences = "preferences",
  help = "help",
  topDestination = "topDestination",
  ExploreCity = "exploreCity",
  FaqAssistance = "faqAssistance",
  TravellerInfo = "travellerInfo",
  FlightDelay = "flightDelay",
  WeatherAdvisory = "weatherAdvisory",
  NewTrip = "newTrip",
  modifyHotels = "modifyHotels",
  modifyFlight = "modifyFlight",
  newBooking = "newBooking",
  BookingLoader = "bookingLoader",
  TripHelp = "tripHelp",
  newPreferences = "newPreferences",
  privacyPolicy = "privacyPolicy",
  termsOfUse = "termsOfUse"
}

export enum localStorageName {
  TriptroveFrequentlyViewTrips = "_triptrove_frequently_view_trips",
  TripTroveUserDetails = "_trip_trove_user_details",
  UserInfo = "user_info",
  AllCategory = "_all_category",
  TripTroveAppConfig = "_trip_trove_app_config",
}

export enum LOGIN_MESSAG {
  Success = "",
}

export enum ACTIVITY_TYPE_IDENTIFIER {
  Flight = "transportation.flight",
  LargeHotel = "accommodations.large_hotel",
  Hotel = "accommodation.hotel",
  Checkout = "accommodation.checkout",
  Activity = "activity",
  Transportation = "transportation",
  Accommodation = "accommodation",
  Restuarant = "restaurant",
}

export enum API_METHODS {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

export enum USER_NAVIGATING_TO_BOOKING_PAGE_FROM {
  HOMEPAGE = "HOMEPAGE",
  ITINERARYDETAILSPAGE = "ITINERARYDETAILSPAGE",
}

export enum HOTEL_CARD_TYPES {
  ADDRESSS = "ADDRESS",
  BOOKING = "BOOKING",
  REFUND = "REFUND",
  SEARCH = "SEARCH",
  ROOM = "ROOM",
  REVIEWANDCONFIRM = "REVIEWANDCONFIRM",
}

export enum SELECT_HOTEL_TYPE {
  HOTEL_TYPE = "HOTEL_TYPE",
  ROOM_TYPE = "ROOM_TYPE",
}

export enum FlightTravelInfoTypes {
  OUTBOUND = "OUTBOUND",
  INBOUND = "INBOUND",
}


export enum ONBOARDING_OPEN_FROM {
  websiteCard = "websiteCard",
  createDestinationList = "createDestinationList",
  bookingWithouFilter = "bookingWithoutFilter",
  // /shared/<id> deep-links. Distinct from `websiteCard` (which is the
  // /itinerary?itineraryId=... flow where the id IS a chat-history id) —
  // /shared/<id> ids are TravelPlan/Itinerary ids, NOT history ids, so they
  // must NOT trigger getSingleHistoryDetail in the auth handlers (the lookup
  // returns empty and resets firstScreen/screen to "", leaving the user on a
  // blank Home after login). Auth handlers' default case handles this value
  // by just navigating Home with empty screens; usePostLoginRedirect then
  // restores the original /shared/<id> URL and ViewShareItinerary renders.
  sharedLink = "sharedLink"
}
